(function () {
  'use strict';

  var translations = window.VinpopShippingTranslations;
  var delivery = window.VinpopDeliveryDate;
  if (!translations || !delivery || typeof delivery.deliveryDate !== 'function' || typeof delivery.label !== 'function') return;

  var langCode = String(document.documentElement.lang || 'en').split('-')[0];
  if (langCode !== 'nl' && langCode !== 'en') return;

  var date = delivery.label(delivery.deliveryDate(), langCode);
  var deliveryText = langCode === 'nl'
    ? 'Op ' + date + ' bij je thuis met DPD 🚚'
    : 'At your door on ' + date + ' with DPD 🚚';

  translations.fastDelivery = deliveryText;
  var legacyFirstOrder = typeof translations.firstOrderAchieved !== 'string';
  if (legacyFirstOrder) {
    var standardDelivery = langCode === 'nl'
      ? 'Standaardverzendkosten zijn van toepassing; gratis vanaf €70 aan wijn.'
      : 'Standard delivery rates apply; free from €70 in wines.';
    ['firstOrderEmpty', 'firstOrderSingular', 'firstOrderPlural', 'firstOrderAchieved'].forEach(function (key) {
      if (typeof translations[key] !== 'string') translations[key] = standardDelivery;
    });
  }

  var datedTranslations = ['freeGoalAchieved', 'firstOrderEmpty', 'firstOrderSingular', 'firstOrderPlural'];
  if (!legacyFirstOrder) datedTranslations.push('firstOrderAchieved');
  datedTranslations.forEach(function (key) {
    if (typeof translations[key] === 'string' && !translations[key].includes(deliveryText)) {
      translations[key] += ' - ' + deliveryText;
    }
  });

  var shippingBar = window.VinpopShippingBar;
  if (shippingBar && typeof shippingBar.update === 'function') shippingBar.update();
})();
